// extracted by mini-css-extract-plugin
export default {"facilitySection":"FacilitySection_facilitySection__hLPCP","slideUp":"FacilitySection_slideUp__S0dNj","slideDown":"FacilitySection_slideDown__5U5N1"};